var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Personal Portfolio Richhapal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--aiZGp2--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.09,85.81a68.12,68.12,0,0,0-4.61,21.06H26.83v-.52l.15-1.43a52.2,52.2,0,0,1,1.23-7.35,56.32,56.32,0,0,1,4.15-11.49.41.41,0,0,1,.45-.28H50.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.53,132.86H32.39a.4.4,0,0,1-.42-.27,52.51,52.51,0,0,1-4.25-13,50.08,50.08,0,0,1-.84-6.56c0-.08,0-.15-.05-.23v-.51l.28,0h18c.33,0,.32,0,.34.33.12,1.5.22,3,.36,4.49A58,58,0,0,0,47,124.2a64.36,64.36,0,0,0,2.43,8.39C49.47,132.67,49.49,132.75,49.53,132.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.61,138.29l-.14.26a51.94,51.94,0,0,1-4.86,6.29,47.09,47.09,0,0,1-7.12,6.56,51,51,0,0,1-8.11,5,50.36,50.36,0,0,1-8.57,3.33,50.93,50.93,0,0,1-7.14,1.52l-.7.12h-.41l-.4-.25c.17-.12.31-.23.46-.32a55,55,0,0,0,13.51-13.11,61.85,61.85,0,0,0,5.53-9.17.39.39,0,0,1,.42-.26h17.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.47,106.86H80.39v-21h18.8a.35.35,0,0,1,.37.25,58,58,0,0,1,3.83,12.33,60.28,60.28,0,0,1,.93,6.68C104.37,105.65,104.42,106.24,104.47,106.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32,112.47c0,.5,0,1-.07,1.49-.1,1.17-.19,2.34-.35,3.51-.23,1.61-.47,3.22-.8,4.82A56.84,56.84,0,0,1,100,132.56a.41.41,0,0,1-.44.31H80.25V112.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,86V107H51.45c0-.53,0-1.05.11-1.57.12-1.18.21-2.37.4-3.53.29-1.79.59-3.57,1-5.34A54.92,54.92,0,0,1,56.33,86.2a.38.38,0,0,1,.4-.26H75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,112.75q0,9.91,0,19.81v.3H56.2a.38.38,0,0,1-.42-.28A53.93,53.93,0,0,1,52.58,122c-.35-1.87-.62-3.76-.85-5.65-.16-1.23-.2-2.48-.28-3.72a.66.66,0,0,1,0-.13l.27,0h23C74.93,112.45,75,112.52,75,112.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,107H110.27a68.58,68.58,0,0,0-4.6-21.2h18.39a.4.4,0,0,1,.43.26A51.79,51.79,0,0,1,129,99.25a57.61,57.61,0,0,1,1,7.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,112.32c0,.47,0,.92-.06,1.37a52.55,52.55,0,0,1-.65,5.32,51.65,51.65,0,0,1-3.63,11.84c-.26.62-.56,1.22-.83,1.83a.26.26,0,0,1-.29.18H106.22c.22-.64.44-1.25.65-1.86a63.83,63.83,0,0,0,2.44-9.61,61.6,61.6,0,0,0,.85-7.16c0-.56.07-1.13.09-1.7,0-.15,0-.22.21-.21H130Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,80.44l0,.08H103.53a.4.4,0,0,1-.42-.24,58.91,58.91,0,0,0-8.56-12.69A48.32,48.32,0,0,0,88,61.53c-1.18-.91-2.4-1.75-3.6-2.63a1.3,1.3,0,0,1-.2-.15l.24-.16c0-.11-.07-.22-.12-.37a51.52,51.52,0,0,1,36.77,22.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62,161.16a1.76,1.76,0,0,1-.5.08,46.47,46.47,0,0,1-5.62-1.09,50.24,50.24,0,0,1-10-3.71,51.1,51.1,0,0,1-10.21-6.7,49.3,49.3,0,0,1-6.13-6.13,51.06,51.06,0,0,1-3.83-5.31.59.59,0,0,1-.08-.16H51.58a.39.39,0,0,1,.4.26A62,62,0,0,0,57.89,148a61.3,61.3,0,0,0,6.92,7.66A53.69,53.69,0,0,0,71.47,161Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.41,58.73c-.74.54-1.6,1.14-2.44,1.79a60.56,60.56,0,0,0-7.78,7.24A54.6,54.6,0,0,0,53,79.42c-.14.26-.26.54-.42.8a.35.35,0,0,1-.25.15c-.29,0-.58,0-.87,0H35.77c8.75-12.36,20.5-19.78,35.46-22,0,.06-.07.13-.11.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.28,138.31a56.11,56.11,0,0,1-8,10.75,50.08,50.08,0,0,1-9.08,7.71V138.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,138.31v18.11a52.36,52.36,0,0,1-16.34-18.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75,80.36H80.39V63.11a49.77,49.77,0,0,1,9.18,7.68A58.62,58.62,0,0,1,96.75,80.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,63.65V80.5H59.26A49.76,49.76,0,0,1,75,63.65Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M705.49,141.31H568.06V51.84H705.49Zm-136.43-1H704.49V52.84H569.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.49,64.59H568.06V51.84H705.49Zm-136.43-1H704.49V52.84H569.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.59,58.3a3,3,0,1,1-3-3A3,3,0,0,1,579.59,58.3Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.67,58.3a3,3,0,1,1-3-3A3,3,0,0,1,591.67,58.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.74,58.3a3,3,0,1,1-3-3A3,3,0,0,1,603.74,58.3Z",
    style: {
      fill: "#58D279"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 422.07 131.79 421.83 212.86 421.74 375 421.58 537.14 421.74 618.21 421.83 699.28 422.07 618.21 422.32 537.14 422.41 375 422.57 212.86 422.41 131.79 422.32 50.72 422.07",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.04,
    y: 79.8,
    width: 565.92,
    height: 342.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.04,
    y: 79.8,
    width: 129.56,
    height: 342.28,
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.9,
    y: 112,
    width: 15.09,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.9,
    y: 122.87,
    width: 15.09,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.9,
    y: 117.49,
    width: 15.09,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.48,123.71v39.42h39.43V123.71Zm3,36.44V126.68h33.47v33.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.44,355.18V394.6h39.43V355.18Zm3,36.45V358.16h33.47v33.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.34,
    y: 321.29,
    width: 62.64,
    height: 4.73,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.85,
    y: 187.33,
    width: 87.17,
    height: 4.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.9,367.75H383.2V153.05H597.9ZM402.12,348.82H579V172H402.12Z",
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "632.02 274.49 544.85 274.49 544.85 187.33 549.58 187.33 549.58 269.76 627.29 269.76 627.29 187.33 632.02 187.33 632.02 274.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.98 326.02 419.25 326.02 419.25 268.11 366.07 268.11 366.07 326.02 361.34 326.02 361.34 263.38 423.98 263.38 423.98 326.02",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.66,
    y: 217.1,
    width: 103.62,
    height: 3.67,
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,248.26c7.42-.2,14.83-.29,22.24-.36l22.24-.11,22.24.11,11.12.13,11.12.23-11.12.23-11.12.13-22.24.11-22.24-.11C266.49,248.55,259.08,248.46,251.66,248.26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,257.91c7.42-.2,14.83-.29,22.24-.36l22.24-.11,22.24.11,11.12.13,11.12.23-11.12.23-11.12.13-22.24.11-22.24-.11C266.49,258.2,259.08,258.1,251.66,257.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,267.56c7.42-.2,14.83-.29,22.24-.36l22.24-.11,22.24.1,11.12.14,11.12.23-11.12.23-11.12.13-22.24.11-22.24-.11C266.49,267.85,259.08,267.75,251.66,267.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,286.86c7.42-.2,14.83-.29,22.24-.37l22.24-.11,22.24.11,11.12.14,11.12.23-11.12.23-11.12.13-22.24.11-22.24-.11C266.49,287.14,259.08,287.05,251.66,286.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,296.51c7.42-.2,14.83-.29,22.24-.37l22.24-.11,22.24.11,11.12.13,11.12.24-11.12.23-11.12.13-22.24.11-22.24-.11C266.49,296.79,259.08,296.7,251.66,296.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,306.16c4.52-.2,9-.29,13.54-.37s9-.07,13.53-.11,9,0,13.53.11l6.77.13c2.26.08,4.51.13,6.77.24-2.26.1-4.51.15-6.77.23l-6.77.13c-4.51.07-9,.07-13.53.11s-9,0-13.53-.11S256.18,306.35,251.66,306.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.04,
    y: 79.8,
    width: 565.92,
    height: 8.86,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08,84.23a2.2,2.2,0,1,1-2.2-2.2A2.19,2.19,0,0,1,99.08,84.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.05,84.23a2.2,2.2,0,1,1-2.2-2.2A2.19,2.19,0,0,1,108.05,84.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,84.23a2.2,2.2,0,1,1-2.2-2.2A2.19,2.19,0,0,1,117,84.23Z",
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.24,
    y: 88.66,
    width: 9.72,
    height: 333.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.09,204.25h0a2.52,2.52,0,0,1-2.51-2.51V93.12a2.51,2.51,0,0,1,2.51-2.51h0a2.51,2.51,0,0,1,2.51,2.51V201.74A2.51,2.51,0,0,1,653.09,204.25Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,160.92H132.71V116.24h62.37ZM133.65,160h60.49V117.18H133.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Texts--inject-48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.04,
    y: 215.76,
    width: 129.56,
    height: 17.14,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,134a2.61,2.61,0,0,0,5.09-.79v-7.52a1.05,1.05,0,0,1,2.1,0v7.52a4.7,4.7,0,0,1-9.18,1.43,1,1,0,0,1,2-.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,136.84V125.67a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v4.54h4.9v-4.54a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.17a1,1,0,0,1-1.06,1,1,1,0,0,1-1-1V132.3h-4.9v4.54a1,1,0,0,1-1.06,1A1,1,0,0,1,132.11,136.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,126.28a6.95,6.95,0,0,1,0,9.57,6.2,6.2,0,0,1-4.52,2,6.39,6.39,0,0,1-4.64-2,7.06,7.06,0,0,1,0-9.57,6.31,6.31,0,0,1,4.64-2A6.13,6.13,0,0,1,156,126.28Zm-.25,4.79a4.87,4.87,0,0,0-1.29-3.31,4,4,0,0,0-3-1.35,4.08,4.08,0,0,0-3.07,1.35,4.82,4.82,0,0,0-1.29,3.31,4.77,4.77,0,0,0,1.29,3.29,4.13,4.13,0,0,0,3.07,1.36,4.08,4.08,0,0,0,3-1.36A4.82,4.82,0,0,0,155.72,131.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,136.84a1,1,0,1,1-2.06,0v-11h0a1,1,0,0,1,.42-.87,1,1,0,0,1,1.44.22l6.11,8.46v-7.8a1,1,0,0,1,1-1,1,1,0,0,1,1,1v11a1.05,1.05,0,0,1-1,1,1,1,0,0,1-.78-.38l-.09-.11-6.06-8.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.88,157.29a1,1,0,0,1,1.38-.13,6.19,6.19,0,0,0,3.62,1.46,4.1,4.1,0,0,0,2.36-.7,1.71,1.71,0,0,0,.82-1.37,1.11,1.11,0,0,0-.17-.6,1.91,1.91,0,0,0-.57-.57,7.65,7.65,0,0,0-2.59-.89h0a9.81,9.81,0,0,1-2.44-.74,4,4,0,0,1-1.76-1.47,2.88,2.88,0,0,1-.44-1.55,3.52,3.52,0,0,1,1.52-2.77,5.61,5.61,0,0,1,3.27-1,7.33,7.33,0,0,1,4.12,1.52,1,1,0,0,1,.27,1.34,1,1,0,0,1-1.34.28,5.55,5.55,0,0,0-3-1.21,3.61,3.61,0,0,0-2.12.65,1.49,1.49,0,0,0-.72,1.19,1,1,0,0,0,.13.53,1.91,1.91,0,0,0,.52.49,6.52,6.52,0,0,0,2.36.83h0a11.26,11.26,0,0,1,2.61.8,4.36,4.36,0,0,1,1.89,1.57,3,3,0,0,1,.46,1.6,3.68,3.68,0,0,1-1.63,2.94,5.94,5.94,0,0,1-3.5,1.08,8.12,8.12,0,0,1-4.85-1.9A1,1,0,0,1,119.88,157.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88,148.38v11.16a1.07,1.07,0,0,1-1.06,1.05,1,1,0,0,1-1-1.05v-8l-2.73,3.78a1,1,0,0,1-.85.44h0a1.06,1.06,0,0,1-.87-.44l-2.7-3.78v8a1.05,1.05,0,1,1-2.1,0V148.38a1,1,0,0,1,1-1h.06a1,1,0,0,1,.83.44l3.76,5.22,3.77-5.22a1,1,0,0,1,.85-.44h0A1.08,1.08,0,0,1,144.88,148.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16,148.38a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.16a1.06,1.06,0,0,1-1.06,1.05,1,1,0,0,1-1-1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,149.44h-3v10.1a1,1,0,0,1-1.05,1.05,1,1,0,0,1-1-1.05v-10.1h-3a1.06,1.06,0,0,1-1-1.06,1,1,0,0,1,1-1h8.08a1,1,0,0,1,1,1A1.06,1.06,0,0,1,164.46,149.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.19,159.54V148.38a1.05,1.05,0,0,1,2.1,0v4.54h4.91v-4.54a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.16a1.05,1.05,0,0,1-1.06,1.05,1,1,0,0,1-1-1.05V155h-4.91v4.54a1.05,1.05,0,1,1-2.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81,246.29a.13.13,0,0,1,.2,0,2.52,2.52,0,0,0,1.53.59,1.74,1.74,0,0,0,1-.3.86.86,0,0,0,.39-.69.73.73,0,0,0-.37-.63,3,3,0,0,0-1.08-.38h0a2.91,2.91,0,0,1-1.09-.39,1,1,0,0,1-.48-.81,1.08,1.08,0,0,1,.48-.87,2,2,0,0,1,1.12-.34A2.54,2.54,0,0,1,122,243a.15.15,0,0,1,0,.21.15.15,0,0,1-.2,0,2.27,2.27,0,0,0-1.27-.49,1.69,1.69,0,0,0-.94.27.81.81,0,0,0-.37.64.67.67,0,0,0,.35.56,2.64,2.64,0,0,0,1,.35h0a3.09,3.09,0,0,1,1.18.43,1,1,0,0,1,.51.87,1.18,1.18,0,0,1-.52.93,2.07,2.07,0,0,1-1.19.36,2.81,2.81,0,0,1-1.71-.67A.14.14,0,0,1,118.81,246.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,242.7a.17.17,0,0,1,.15-.17.17.17,0,0,1,.17.17v2.68l2.8-2.8a.16.16,0,1,1,.23.23l-1.78,1.78,1.82,2.3a.17.17,0,0,1,0,.23.15.15,0,0,1-.11,0,.17.17,0,0,1-.12-.06L125,244.82l-1,1V247a.17.17,0,0,1-.17.16.16.16,0,0,1-.15-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,242.68a.16.16,0,0,1,.32,0V247a.16.16,0,0,1-.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,247.16h0a.16.16,0,0,1-.16-.16v-4.32a.16.16,0,0,1,.32,0v4.15h2.22a.17.17,0,0,1,.17.17.17.17,0,0,1-.17.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,247.16h0a.16.16,0,0,1-.16-.16v-4.32a.16.16,0,0,1,.32,0v4.15h2.22a.16.16,0,0,1,.16.17.16.16,0,0,1-.16.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.43,246.29a.15.15,0,0,1,.21,0,2.49,2.49,0,0,0,1.52.59,1.71,1.71,0,0,0,1-.3.85.85,0,0,0,.4-.69.74.74,0,0,0-.38-.63,2.83,2.83,0,0,0-1.07-.38h0a3,3,0,0,1-1.09-.39,1,1,0,0,1-.48-.81,1.09,1.09,0,0,1,.49-.87,1.91,1.91,0,0,1,1.12-.34,2.56,2.56,0,0,1,1.43.54.17.17,0,0,1,0,.21.16.16,0,0,1-.2,0,2.3,2.3,0,0,0-1.27-.49,1.7,1.7,0,0,0-1,.27.82.82,0,0,0-.36.64.66.66,0,0,0,.34.56,2.71,2.71,0,0,0,1,.35h0a3.22,3.22,0,0,1,1.18.43,1,1,0,0,1,.51.87,1.19,1.19,0,0,1-.53.93,2.07,2.07,0,0,1-1.19.36,2.83,2.83,0,0,1-1.71-.67A.15.15,0,0,1,138.43,246.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,204.1h-2.39v2a.16.16,0,0,1-.32,0v-4.32a.16.16,0,1,1,.32,0v2h2.39v-2a.16.16,0,1,1,.32,0v4.32a.16.16,0,1,1-.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,201.56a2.35,2.35,0,1,1-2.24,2.35A2.28,2.28,0,0,1,125.75,201.56Zm0,4.37a2,2,0,0,0,0-4,2,2,0,0,0,0,4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.85,202.29l-1.48,2.05a.14.14,0,0,1-.13.08h0a.14.14,0,0,1-.14-.08l-1.49-2.05v3.81a.16.16,0,1,1-.32,0v-4.29a.18.18,0,0,1,.06-.13h0a.16.16,0,0,1,.22,0l1.65,2.28,1.64-2.28a.17.17,0,0,1,.23,0l.05.05a.29.29,0,0,1,0,.09v4.29a.16.16,0,1,1-.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74,201.78a.16.16,0,0,1,.16-.16h2.38a.16.16,0,0,1,.16.16.17.17,0,0,1-.16.17h-2.22v1.83H137a.16.16,0,0,1,.16.17.16.16,0,0,1-.16.16h-1.94v1.82h2.22a.17.17,0,0,1,.16.17.16.16,0,0,1-.16.16h-2.4a.15.15,0,0,1-.14-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,172h0s0,0,0,0v0h-.15l0,0h0s0,0,0,0h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0l-.69-2.8-1.7,2.85h0a0,0,0,0,1,0,0v0h-.15l0,0h0s0,0,0,0h0l0-.05L142,167.64a.17.17,0,0,1,.12-.2.15.15,0,0,1,.19.12l1,3.93,1.68-2.82a.18.18,0,0,1,.15-.08.17.17,0,0,1,.17.12l.68,2.78,2.37-4a.17.17,0,0,1,.23-.06.16.16,0,0,1,.05.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.75,171.89l.76-4.31a.17.17,0,0,1,.17-.13h2.38a.16.16,0,0,1,0,.32h-2.25l-.32,1.83h1.92a.17.17,0,0,1,.16.16.17.17,0,0,1-.16.17h-2l-.33,1.83h2.2a.16.16,0,0,1,0,.32h-2.41A.18.18,0,0,1,149.75,171.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.89,171.87l.75-4.31a.17.17,0,0,1,.17-.13h1a1,1,0,0,1,.72.28,1,1,0,0,1,.28.7,1.23,1.23,0,0,1,0,.19,1.4,1.4,0,0,1-.59.89,1.15,1.15,0,0,1,.37.25,1.11,1.11,0,0,1,.32.79,1.79,1.79,0,0,1,0,.23,1.61,1.61,0,0,1-1.53,1.3H154A.16.16,0,0,1,153.89,171.87Zm1.88-2.13h-1.18l-.35,2h1.12a1.3,1.3,0,0,0,1.21-1,1.1,1.1,0,0,0,0-.18A.78.78,0,0,0,155.77,169.74Zm.06-2h-.89l-.29,1.66h.83a1.08,1.08,0,0,0,1-.86.71.71,0,0,0,0-.14A.64.64,0,0,0,155.83,167.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,171.88l.76-4.31a.15.15,0,0,1,.16-.13H162a1.9,1.9,0,0,1,2,1.94,2.8,2.8,0,0,1,0,.4,2.85,2.85,0,0,1-2.7,2.3h-.89A.17.17,0,0,1,160.2,171.88Zm.35-.13h.67a2.52,2.52,0,0,0,2.38-2,2.16,2.16,0,0,0,0-.35,1.58,1.58,0,0,0-1.64-1.62h-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.16,171.89l.76-4.31a.16.16,0,0,1,.16-.13h2.39a.16.16,0,0,1,0,.32h-2.25l-.33,1.83h1.92a.16.16,0,0,1,.16.16.16.16,0,0,1-.16.17h-2l-.32,1.83h2.2a.16.16,0,0,1,0,.32h-2.42A.16.16,0,0,1,165.16,171.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.08,171.21a.13.13,0,0,1,.2,0,2.16,2.16,0,0,0,1.39.59,1.92,1.92,0,0,0,1.06-.31,1,1,0,0,0,.51-.68.6.6,0,0,0-.25-.62,2.72,2.72,0,0,0-1-.37h0a2.6,2.6,0,0,1-1-.38.77.77,0,0,1-.32-.8,1.33,1.33,0,0,1,.62-.86,2.15,2.15,0,0,1,1.15-.33,2.11,2.11,0,0,1,1.33.53.13.13,0,0,1,0,.2.15.15,0,0,1-.21,0,1.92,1.92,0,0,0-1.16-.48,1.82,1.82,0,0,0-1,.28,1,1,0,0,0-.47.62.52.52,0,0,0,.24.55,2.13,2.13,0,0,0,.92.35h0a2.54,2.54,0,0,1,1.08.42.84.84,0,0,1,.36.85,1.4,1.4,0,0,1-.68.91,2.24,2.24,0,0,1-1.24.37,2.38,2.38,0,0,1-1.56-.66A.14.14,0,0,1,169.08,171.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,172.08a.15.15,0,0,1-.13-.18l.76-4.31a.16.16,0,0,1,.18-.14.18.18,0,0,1,.14.19l-.77,4.31a.15.15,0,0,1-.16.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,171.5a1.91,1.91,0,0,1-.58-1.4,1.78,1.78,0,0,1,0-.39,2.86,2.86,0,0,1,2.75-2.29,2.1,2.1,0,0,1,1.41.51.17.17,0,0,1,0,.23.16.16,0,0,1-.23,0,1.76,1.76,0,0,0-1.19-.43,2.56,2.56,0,0,0-2.43,2,2.23,2.23,0,0,0,0,.34,1.61,1.61,0,0,0,1.71,1.63,2.49,2.49,0,0,0,1.32-.4l.23-1.33h-1.22a.16.16,0,0,1-.16-.16.16.16,0,0,1,.16-.17h1.44a.15.15,0,0,1,.13.18l-.27,1.58s0,0,0,.05h0s0,.05-.06.06a2.75,2.75,0,0,1-1.55.5A2,2,0,0,1,176.48,171.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,167.58a0,0,0,0,0,0,0,.16.16,0,0,1,.08-.13.15.15,0,0,1,.21.07l2.14,3.91.67-3.84a.16.16,0,0,1,.19-.13.17.17,0,0,1,.13.19l-.75,4.28a.18.18,0,0,1-.16.14h0a.2.2,0,0,1-.12-.08s0,0,0,0l-2.11-3.88-.69,3.85a.16.16,0,0,1-.16.14h0a.16.16,0,0,1-.13-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.05,171.89l.76-4.31a.15.15,0,0,1,.16-.13h2.39a.16.16,0,0,1,0,.32h-2.25l-.33,1.83h1.92a.16.16,0,0,1,.16.16.16.16,0,0,1-.16.17h-2l-.32,1.83h2.2a.16.16,0,0,1,0,.32h-2.42A.16.16,0,0,1,187.05,171.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,170.28a1.31,1.31,0,0,0-.44-.2h-1.17l-.33,1.86a.16.16,0,0,1-.15.13h0a.17.17,0,0,1-.13-.18l.76-4.31a.17.17,0,0,1,.17-.14h1.3a1.11,1.11,0,0,1,1.14,1.12,1.79,1.79,0,0,1,0,.23,1.63,1.63,0,0,1-1,1.19,1,1,0,0,1,.51.87,1.8,1.8,0,0,1,0,.22,2.31,2.31,0,0,0,0,.4.51.51,0,0,0,0,.21.16.16,0,0,1,.17.12.15.15,0,0,1-.11.2h-.08a.32.32,0,0,1-.24-.13.75.75,0,0,1-.1-.41,3,3,0,0,1,0-.46,1,1,0,0,0,0-.16A.68.68,0,0,0,193.34,170.28Zm-1.55-.52h1.11a1.3,1.3,0,0,0,1.21-1,1.1,1.1,0,0,0,0-.18.77.77,0,0,0-.82-.79h-1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,222.23a.16.16,0,0,1,.16-.16h1a1.15,1.15,0,0,1,.71,2.06,1.32,1.32,0,0,1-.42,2.58h-1.33a.16.16,0,0,1-.15-.16Zm1.19,1.82a.83.83,0,1,0,0-1.65h-.87v1.65Zm.29,2.33a1,1,0,0,0,0-2h-1.16v2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,222.23a.16.16,0,0,1,.16-.16.17.17,0,0,1,.17.16v4.32a.17.17,0,0,1-.17.16.17.17,0,0,1-.16-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.34,222a2.35,2.35,0,1,1-2.24,2.35A2.28,2.28,0,0,1,127.34,222Zm0,4.37a2,2,0,1,0-1.92-2A2,2,0,0,0,127.34,226.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,263.13a.16.16,0,0,1,.16-.16h1.31a1.32,1.32,0,1,1,0,2.64h-1.15v1.83a.16.16,0,1,1-.32,0Zm1.47,2.17a1,1,0,0,0,0-2h-1.15v2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.11,262.9a2.36,2.36,0,1,1-2.24,2.35A2.29,2.29,0,0,1,125.11,262.9Zm0,4.38a2,2,0,1,0-1.91-2A2,2,0,0,0,125.11,267.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.21,266.56a.83.83,0,0,0-.37-.7,1.69,1.69,0,0,0-.54-.24h-1.16v1.84a.17.17,0,0,1-.17.16.16.16,0,0,1-.15-.16v-4.32A.16.16,0,0,1,129,263h1.33a1.32,1.32,0,0,1,.55,2.52l.07,0a1.18,1.18,0,0,1,.62,1,1.93,1.93,0,0,0,.06.54.33.33,0,0,0,.07.11.17.17,0,0,1,.18.1.22.22,0,0,1-.11.22h-.09a.35.35,0,0,1-.3-.21A1.61,1.61,0,0,1,131.21,266.56Zm-.92-3.27h-1.15v2h1.17a1,1,0,0,0,0-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.31,263.29h-1.4a.16.16,0,0,1,0-.32H136a.16.16,0,0,1,0,.32h-1.4v4.16a.16.16,0,0,1-.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,263.13a.16.16,0,0,1,.16-.16h2.39a.16.16,0,0,1,0,.32h-2.22v1.84h1.95a.16.16,0,0,1,0,.32h-1.95v2a.17.17,0,0,1-.17.16.17.17,0,0,1-.16-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.71,262.9a2.36,2.36,0,1,1-2.24,2.35A2.29,2.29,0,0,1,143.71,262.9Zm0,4.38a2,2,0,1,0-1.91-2A2,2,0,0,0,143.71,267.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,267.61h0a.16.16,0,0,1-.16-.16v-4.32a.16.16,0,0,1,.16-.16.17.17,0,0,1,.17.16v4.15H150a.16.16,0,0,1,.17.17.17.17,0,0,1-.17.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.48,263.13a.16.16,0,0,1,.32,0v4.32a.16.16,0,0,1-.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,262.9a2.36,2.36,0,1,1-2.23,2.35A2.28,2.28,0,0,1,155.68,262.9Zm0,4.38a2,2,0,1,0-1.91-2A2,2,0,0,0,155.68,267.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,283.35a2.46,2.46,0,0,1,1.49.51c.07.06.09.18,0,.23a.16.16,0,0,1-.23,0,2.08,2.08,0,0,0-1.29-.45,2,2,0,1,0,0,4.05,2,2,0,0,0,1.28-.45.16.16,0,0,1,.23,0,.15.15,0,0,1,0,.23,2.45,2.45,0,0,1-1.49.5,2.35,2.35,0,1,1,0-4.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.23,283.35A2.35,2.35,0,1,1,124,285.7,2.28,2.28,0,0,1,126.23,283.35Zm0,4.38a2,2,0,1,0-1.92-2A2,2,0,0,0,126.23,287.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,284.1v3.8a.16.16,0,0,1-.16.15.16.16,0,0,1-.16-.15v-4.26a.15.15,0,0,1,.06-.17.16.16,0,0,1,.22,0l2.81,3.9v-3.78a.16.16,0,0,1,.16-.15.17.17,0,0,1,.17.15v4.28a.18.18,0,0,1-.3.1l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.29,283.74h-1.4a.16.16,0,0,1,0-.32H138a.16.16,0,0,1,0,.32h-1.4v4.16a.16.16,0,0,1-.16.15.15.15,0,0,1-.15-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,286.86h-2.11L139,288a.15.15,0,0,1-.15.1h-.06a.16.16,0,0,1-.09-.21l1.61-4.3a.17.17,0,0,1,.16-.1.15.15,0,0,1,.15.1l1.61,4.3a.16.16,0,0,1-.08.21h-.06a.16.16,0,0,1-.15-.1Zm-2-.33h1.88l-.94-2.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.37,283.35a2.44,2.44,0,0,1,1.49.51.16.16,0,0,1,0,.23.16.16,0,0,1-.23,0,2,2,0,1,0-1.29,3.6,2,2,0,0,0,1.28-.45.16.16,0,0,1,.23,0,.15.15,0,0,1,0,.23,2.43,2.43,0,0,1-1.49.5,2.35,2.35,0,1,1,0-4.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.66,283.74h-1.39a.16.16,0,1,1,0-.32h3.11a.16.16,0,0,1,0,.32H150v4.16a.16.16,0,0,1-.16.15.16.16,0,0,1-.16-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.63,201.84V190.68a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v4.54h4.9v-4.54a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.16a1,1,0,0,1-1.06,1,1,1,0,0,1-1-1V197.3h-4.9v4.54a1,1,0,0,1-1.06,1A1,1,0,0,1,253.63,201.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8,190.68a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.16a1,1,0,0,1-1.06,1,1,1,0,0,1-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,198.32v-7.64a1,1,0,0,1,1-1,1,1,0,0,1,1,1v7.64a1,1,0,0,1-1,1A1,1,0,0,1,272.8,198.32Zm1,4.56a1,1,0,0,1-1-1v-.38a1.05,1.05,0,0,1,1-1,1,1,0,0,1,1,1v.38A1,1,0,0,1,273.84,202.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.76,213.39a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.16a1,1,0,0,1-1.06,1,1,1,0,0,1-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.55,216.64a1.61,1.61,0,0,0,1.29-1.7,1.34,1.34,0,0,1-1.08-1.27v-.15a1.23,1.23,0,0,1,1.29-1.27c.83,0,1.36.65,1.36,1.67v.19a3.73,3.73,0,0,1-.93,2.76,2.75,2.75,0,0,1-1.77.81c-.4,0-.59-.22-.59-.53A.55.55,0,0,1,259.55,216.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.28,213.39v11.16a1.06,1.06,0,0,1-1.06,1,1,1,0,0,1-1-1v-8l-2.72,3.79a1,1,0,0,1-.86.43h0a1.06,1.06,0,0,1-.87-.43L267,216.58v8a1.05,1.05,0,0,1-2.1,0V213.39a1,1,0,0,1,1-1H266a1,1,0,0,1,.83.43l3.77,5.22,3.76-5.22a1,1,0,0,1,.85-.43h0A1.08,1.08,0,0,1,276.28,213.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.68,221.69a2.61,2.61,0,0,0,5.09-.79v-7.51a1.05,1.05,0,0,1,2.1,0v7.51a4.71,4.71,0,0,1-9.18,1.44,1,1,0,0,1,.66-1.31A1,1,0,0,1,288.68,221.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,224.55V213.39a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v4.54h4.9v-4.54a1,1,0,0,1,1-1,1,1,0,0,1,1.06,1v11.16a1,1,0,0,1-1.06,1,1,1,0,0,1-1-1V220h-4.9v4.54a1,1,0,0,1-1.06,1A1,1,0,0,1,299.48,224.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.34,214a7,7,0,0,1,0,9.58,6.18,6.18,0,0,1-4.52,2,6.4,6.4,0,0,1-4.64-2,7.07,7.07,0,0,1,0-9.58,6.32,6.32,0,0,1,4.64-2A6.1,6.1,0,0,1,323.34,214Zm-.24,4.79a4.92,4.92,0,0,0-1.29-3.31,4.11,4.11,0,0,0-3-1.35,4.15,4.15,0,0,0-3.07,1.35,4.82,4.82,0,0,0-1.28,3.31,4.73,4.73,0,0,0,1.28,3.29,4.05,4.05,0,0,0,6.06,0A4.83,4.83,0,0,0,323.1,218.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.14,224.55a1,1,0,1,1-2.06,0v-11a1,1,0,0,1,.41-.87,1,1,0,0,1,1.44.23l6.11,8.45v-7.79a1,1,0,0,1,1-1,1,1,0,0,1,1,1v11a1,1,0,0,1-1,1,1,1,0,0,1-.77-.38.5.5,0,0,1-.1-.11l-6.05-8.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.66,
    y: 319.08,
    width: 52.36,
    height: 15.39,
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,328a.15.15,0,0,1,.21,0,2.56,2.56,0,0,0,1.52.6,1.69,1.69,0,0,0,1-.31.86.86,0,0,0,.4-.69.74.74,0,0,0-.38-.63,2.83,2.83,0,0,0-1.07-.38h0a3,3,0,0,1-1.1-.39,1,1,0,0,1-.47-.81,1.08,1.08,0,0,1,.48-.87,1.91,1.91,0,0,1,1.12-.34,2.54,2.54,0,0,1,1.43.54.15.15,0,0,1,0,.21.15.15,0,0,1-.2,0,2.27,2.27,0,0,0-1.27-.49,1.7,1.7,0,0,0-.95.27.82.82,0,0,0-.36.64.66.66,0,0,0,.34.56,2.7,2.7,0,0,0,1,.35h0a3.22,3.22,0,0,1,1.18.43,1,1,0,0,1,.51.87,1.16,1.16,0,0,1-.53.93,2,2,0,0,1-1.19.36,2.83,2.83,0,0,1-1.71-.67A.15.15,0,0,1,260.9,328Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.73,324.43a.16.16,0,0,1,.16-.16h2.38a.16.16,0,1,1,0,.32h-2.21v1.84H268a.16.16,0,1,1,0,.32h-1.94v1.83h2.21a.16.16,0,0,1,.16.17.16.16,0,0,1-.16.16h-2.39a.17.17,0,0,1-.15-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,324.43a.16.16,0,0,1,.16-.16h2.38a.16.16,0,1,1,0,.32h-2.22v1.84h1.94a.16.16,0,0,1,0,.32h-1.94v1.83h2.22a.16.16,0,0,1,.16.17.16.16,0,0,1-.16.16H270a.16.16,0,0,1-.14-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.75,324.93,278.26,327a.16.16,0,0,1-.13.08h0A.16.16,0,0,1,278,327l-1.49-2.05v3.81a.16.16,0,0,1-.15.16.17.17,0,0,1-.17-.16v-4.29a.16.16,0,0,1,.07-.13h0a.15.15,0,0,1,.22,0l1.65,2.28,1.65-2.28a.15.15,0,0,1,.22,0l.05.05a.29.29,0,0,1,0,.09v4.29a.16.16,0,0,1-.16.16.16.16,0,0,1-.15-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.69,324.2a2.36,2.36,0,1,1-2.24,2.36A2.29,2.29,0,0,1,283.69,324.2Zm0,4.38a2,2,0,0,0,0-4,2,2,0,0,0,0,4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.79,327.86a.82.82,0,0,0-.38-.7,1.33,1.33,0,0,0-.53-.23l0,0h-1.13v1.84a.17.17,0,0,1-.17.16.16.16,0,0,1-.15-.16v-4.32a.16.16,0,0,1,.14-.16h1.33a1.32,1.32,0,0,1,.55,2.52l.07,0a1.18,1.18,0,0,1,.62,1,1.93,1.93,0,0,0,.06.54.23.23,0,0,0,.07.11.15.15,0,0,1,.17.11.19.19,0,0,1-.1.21h-.09a.35.35,0,0,1-.3-.21A1.61,1.61,0,0,1,289.79,327.86Zm-.92-3.27h-1.15v2h1.17a1,1,0,0,0,1-1A1,1,0,0,0,288.87,324.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,324.43a.16.16,0,0,1,.15-.16h2.39a.16.16,0,0,1,0,.32h-2.22v1.84h1.94a.16.16,0,1,1,0,.32h-1.94v1.83h2.22a.16.16,0,0,1,.16.17.16.16,0,0,1-.16.16H292a.16.16,0,0,1-.14-.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.92,237.33c-29.25,29.64-66,92-59.18,104.65,7.64,14.08,48.36-27.48,48.21-29.91-.12-1.83,14.21-39.71,25.07-67.26S456.15,230,448.92,237.33Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.22,312.12c1.25-4.05,20.74-54,26.31-69.8s.41-20.68-15.51-6.21-50.8,62.79-58.76,88.45c-7.67,24.71,5.05,24.71,21.84,13.32C425.84,328.55,438.22,312.12,438.22,312.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.56,240.58a11.46,11.46,0,0,1,1,3.2,12,12,0,0,1-1.78-2.84,12.17,12.17,0,0,1-1-3.2A12,12,0,0,1,453.56,240.58Zm-51.78,63a11.57,11.57,0,0,0,1,3.2,12,12,0,0,0,1.78,2.84,11.46,11.46,0,0,0-1-3.2A12,12,0,0,0,401.78,303.59ZM419,277.35a12.4,12.4,0,0,0,1,3.2,11.7,11.7,0,0,0,1.78,2.83,11.67,11.67,0,0,0-1-3.2A11.9,11.9,0,0,0,419,277.35Zm16.85-2a11.82,11.82,0,0,0,3.2-1,11.6,11.6,0,0,0,2.84-1.77,11.46,11.46,0,0,0-3.2,1A11.64,11.64,0,0,0,435.87,275.38Zm-16.14,26.53a11.5,11.5,0,0,0,3.19-1,11.76,11.76,0,0,0,2.84-1.78,11.57,11.57,0,0,0-3.2,1A11.7,11.7,0,0,0,419.73,301.91Zm13.12-45.45a12.17,12.17,0,0,0,3.2-1,12,12,0,0,0,2.84-1.78,11.46,11.46,0,0,0-3.2,1A12,12,0,0,0,432.85,256.46Zm13.6,30.39a12.94,12.94,0,0,0-2.31,6.23,13,13,0,0,0,2.31-6.23Zm-33.78,31.62a12.94,12.94,0,0,0-2.31,6.23,12.94,12.94,0,0,0,2.31-6.23Zm18.73-2.8a10.59,10.59,0,0,0,2.75,1.47l.59-.7-.07,0A11.62,11.62,0,0,0,431.4,315.67ZM397.9,336a12.94,12.94,0,0,0-6.23-2.31,11.42,11.42,0,0,0,3,1.56A11.82,11.82,0,0,0,397.9,336Zm53.53-74.68a11.6,11.6,0,0,0,3,1.55,12.06,12.06,0,0,0,2.25.62c0-.14.1-.29.16-.44a14.07,14.07,0,0,0-2.12-1A11.38,11.38,0,0,0,451.43,261.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.72,348.82H552.91s-17.67-87.21-60.32-125c-5.27-4.67-17.16-3.61-24.91.25-2.77,1.37-12.72,15.28-15.55,28.43S441.4,348.42,441.72,348.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.16,258c-.87,2.94-1.59,6-2.18,9,0-.12,0-.24,0-.36,0-1.72-.06-3.47-.24-5.18a.09.09,0,0,0-.17,0,26.68,26.68,0,0,0-.14,5.21c0,.82.1,1.65.17,2.47-.24,1.37-.45,2.74-.62,4.11-.33,2.59-1.2,12.25-1.27,14.17,0,.41.45.47.56.06.52-1.95,1.91-11.91,2.35-14.47a140.6,140.6,0,0,0,1.76-15C451.37,257.88,451.19,257.88,451.16,258Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.4,249.46a11.46,11.46,0,0,1,1,3.2,12.93,12.93,0,0,1-2.77-6A12,12,0,0,1,487.4,249.46Zm11.51,38.61a11.46,11.46,0,0,0,1,3.2,12,12,0,0,0,1.78,2.84,11.46,11.46,0,0,0-1-3.2A12,12,0,0,0,498.91,288.07ZM535,303.92a11.46,11.46,0,0,0,1,3.2A11.76,11.76,0,0,0,537.8,310a11.57,11.57,0,0,0-1-3.2A12,12,0,0,0,535,303.92Zm-26.55,28.39a12.93,12.93,0,0,0,2.77,6,12.28,12.28,0,0,0-1-3.2A12,12,0,0,0,508.48,332.31Zm-46.36-54.85a11.67,11.67,0,0,0,1,3.2,11.9,11.9,0,0,0,1.78,2.83,12.84,12.84,0,0,0-2.77-6Zm-14.61,30.13a11.86,11.86,0,0,0,1,3.19,11.42,11.42,0,0,0,1.77,2.84,11.67,11.67,0,0,0-1-3.2A11.4,11.4,0,0,0,447.51,307.59Zm35.35,21.71a12.84,12.84,0,0,0,2.77,6,12,12,0,0,0-1-3.2A11.9,11.9,0,0,0,482.86,329.3Zm33.88-58.74a11.46,11.46,0,0,0,1,3.2,11.35,11.35,0,0,0,1.78,2.84,13.2,13.2,0,0,0-2.77-6Zm-43.1-5.29a12.4,12.4,0,0,0,3.2-1,11.7,11.7,0,0,0,2.83-1.78,11.5,11.5,0,0,0-3.19,1A11.76,11.76,0,0,0,473.64,265.27Zm-7,35.78a12.21,12.21,0,0,0,3.19-1,11.76,11.76,0,0,0,2.84-1.78,11.57,11.57,0,0,0-3.2,1A11.7,11.7,0,0,0,466.63,301.05ZM532,339a11.8,11.8,0,0,0,3.2-1,12,12,0,0,0,2.84-1.78,11.46,11.46,0,0,0-3.2,1A12,12,0,0,0,532,339Zm-65.79,6.66,1.78-.11.68-.3a12.16,12.16,0,0,0,2.84-1.78,11.65,11.65,0,0,0-3.21,1A12.87,12.87,0,0,0,466.22,345.62ZM507,310a12.93,12.93,0,0,0,6-2.77,12.93,12.93,0,0,0-6,2.77Zm-33.37-76.4a11.67,11.67,0,0,0,3.2-1,11.4,11.4,0,0,0,2.83-1.78,12.21,12.21,0,0,0-3.19,1A11.76,11.76,0,0,0,473.64,233.59ZM470,245.15a13,13,0,0,0-2.31,6.22,11.22,11.22,0,0,0,1.56-3A11.48,11.48,0,0,0,470,245.15Zm-17.66,82.76a12.94,12.94,0,0,0-2.31,6.23,11.46,11.46,0,0,0,1.57-3A11.73,11.73,0,0,0,452.36,327.91Zm47.7-62a12.94,12.94,0,0,0-2.31,6.23,11.13,11.13,0,0,0,1.56-3A11.74,11.74,0,0,0,500.06,266Zm-13.73,36.43a12.94,12.94,0,0,0-2.31,6.23,12.94,12.94,0,0,0,2.31-6.23ZM549,348.82h.29c0-.15,0-.31,0-.46Zm-31.18,0h.9l.12-.31a11.73,11.73,0,0,0,.74-3.26,11.73,11.73,0,0,0-1.56,3C517.93,348.41,517.86,348.62,517.8,348.82Zm7.34-29.54a13,13,0,0,0-2.31,6.22,13,13,0,0,0,2.31-6.22Zm-26.93-85.73a13,13,0,0,0-2.31,6.22,11.52,11.52,0,0,0,1.56-3A11.82,11.82,0,0,0,498.21,233.55Zm-27.24,88a11.88,11.88,0,0,0-3-1.57,11.53,11.53,0,0,0-3.27-.74,13,13,0,0,0,6.23,2.31Zm29.11,26.77a12.94,12.94,0,0,0-6.23-2.31,11.22,11.22,0,0,0,3,1.56A11.89,11.89,0,0,0,500.08,348.36Zm45-25.17a8.77,8.77,0,0,0,1.51.93l-.23-.76A9,9,0,0,0,545,323.19ZM524.2,293.27A13,13,0,0,0,518,291a11.52,11.52,0,0,0,3,1.56A11.82,11.82,0,0,0,524.2,293.27Zm-23.33,29.47a13,13,0,0,0-6.23-2.31,12.94,12.94,0,0,0,6.23,2.31ZM487,280.47a13,13,0,0,0-6.22-2.31,11.56,11.56,0,0,0,3,1.57A11.81,11.81,0,0,0,487,280.47Zm-29.33-16.82a12.08,12.08,0,0,0-3-1.56,11.82,11.82,0,0,0-3.26-.75,11.22,11.22,0,0,0,3,1.56A11.81,11.81,0,0,0,457.67,263.65Zm52.46-9.83a11.77,11.77,0,0,0-3-1.57,11.39,11.39,0,0,0-3.26-.74,12.94,12.94,0,0,0,6.23,2.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74,342c6.58,9.41,24.5,11.21,69.2,20,6.18,1.21,26.48-40.13,19.94-41.77-8.24-2.05-40.64-8.25-43.07-8.41C415.34,310.46,385.27,335.59,389.74,342Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.94,318.13s18.93,2.87,28.42,7.45c12.69,6.14,21.13,16.66,24.4,21.29,6.82,9.65,16.65,37.71,9.06,41.95-6.87,3.84-15.46-25.35-15.46-25.35s13.67,28.31,4.55,31.41-17.17-31.35-17.17-31.35,13.4,29.41,3.49,31.12c-7.49,1.29-16.54-29.5-16.54-29.5s11.34,25.36,3.7,27C485.94,394,475.8,366.1,475.8,366.1c-20.14.95-30.12-6.84-36.56-13.22C437.68,351.33,469.94,318.13,469.94,318.13Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.26,353.37c1.72,3.27,3.49,6.57,4.92,10s2.74,6.87,3.85,10.4a63.5,63.5,0,0,1,3,14.13c-1.44-8.48-6.37-20.76-7.8-24.17s-2.68-6.88-4.11-10.29C512.09,353.34,512.21,353.3,512.26,353.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.85,358.31c2,4.27,4.19,8.43,6,12.79s3.19,8.62,4.71,13.07c.12.34-.11.29-.24-.05-1.7-4.39-3.61-8.31-5.36-12.68s-3.33-8.8-5.24-13.09C499.71,358.29,499.82,358.25,499.85,358.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.44,360.64c3.42,6.36,5.67,13.35,7.72,20.26.1.34-.18.25-.31-.1-2.44-6.78-4.3-12.12-7.63-20C488.16,360.63,488.37,360.5,488.44,360.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.89,318.13l-39.16,43.61s-39.6-9.09-45.44-19.24c-3.84-6.69,26-33.77,48.48-30.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.89,348.18a11.57,11.57,0,0,1,1,3.2,11.42,11.42,0,0,1-1.77-2.84,11.82,11.82,0,0,1-1-3.2A12,12,0,0,1,440.89,348.18Zm-30.76-8.12a12.17,12.17,0,0,0,1,3.2,11.76,11.76,0,0,0,1.78,2.84,11.46,11.46,0,0,0-1-3.2A12,12,0,0,0,410.13,340.06Zm18.34-4.54a12.93,12.93,0,0,0,6-2.77,12.17,12.17,0,0,0-3.2,1A12,12,0,0,0,428.47,335.52Zm-15.8-17a12.94,12.94,0,0,0-2.31,6.23,12.94,12.94,0,0,0,2.31-6.23Zm39.69,9.44a12.94,12.94,0,0,0-2.31,6.23,11.46,11.46,0,0,0,1.57-3A11.73,11.73,0,0,0,452.36,327.91ZM471,321.59a11.88,11.88,0,0,0-3-1.57,11.53,11.53,0,0,0-3.27-.74,13,13,0,0,0,6.23,2.31ZM437.62,318a11.52,11.52,0,0,0-3-1.56,11.15,11.15,0,0,0-3.26-.75,13,13,0,0,0,6.22,2.31Zm-12.33,38.34a11.84,11.84,0,0,0-3-1.56,11.54,11.54,0,0,0-3.27-.75,13,13,0,0,0,6.23,2.31Zm-33-22.15a12.66,12.66,0,0,0,2.32,1.11,11.74,11.74,0,0,0,3.27.76,12.47,12.47,0,0,0-3-1.57,14.6,14.6,0,0,0-2.35-.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.92,319c3.63-2.63,13.85-8.76,26.88-7.13.12,0,.12.21,0,.2-9.82-.28-23.08,4.86-26.79,7.1C410.91,319.2,410.83,319.05,410.92,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,354.44c4.05-5,8.36-9.83,12.69-14.62s8.65-9.6,13.1-14.29c2.51-2.65,5-5.31,7.62-7.87.06-.07.19,0,.13.1-4,5-8.34,9.85-12.63,14.66s-8.65,9.61-13,14.35c-2.48,2.68-5,5.31-7.62,7.88C424.14,354.77,423.9,354.59,424,354.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,317.57a55.69,55.69,0,0,0-7.34-1.67c-2.47-.47-4.95-.89-7.44-1.29-4.93-.79-15.3-3-24.42-3-.1,0,.42.49.52.48,4.34-.23,35.44,6,38,6.14a3.66,3.66,0,0,0-.28.52c-.05.12.08.29.21.19.32-.21.55-.48.85-.72A.36.36,0,0,0,474,317.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.89,189.58c.23-5.34-.85-29.91-2.68-36.69s-8.51-25.87-13.84-25-3.82,6.62-3.82,6.62-4.09-7.62-9.38-6.25-2.64,10.24-2.64,10.24-4.78-7.52-9.95-5.78-1,10.21-1,10.21-4-7.07-7.71-3.84c-4.4,3.88,4.54,16.08,6,23.71.33,1.73,4.22,35.58,4.22,35.58Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.22,142.21c6.55,9,7.86,14.06,8.59,25a.17.17,0,0,0,.34,0c.26-10.76-.47-17.36-8.52-25.34C545.24,141.48,544.9,141.78,545.22,142.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556,137.8c6,9.93,7.46,15.42,9.06,26.81,0,.16.3.14.29,0-.64-11.3-1.52-17.86-8.8-27C556.22,137.16,555.72,137.35,556,137.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.62,135.1c5.1,10,7,16,7.11,27.24a.21.21,0,0,0,.42,0c1-11.5-1.31-18.93-7.21-27.38C568.54,134.4,568.3,134.47,568.62,135.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.41,205.38s-10.15-9.55-13.68-14.73-9.6-29.34-4.46-31c6.64-2.07,12.89,11.19,15.1,18.08,0,0,15.35-4.81,21.9,3.73S548.41,205.38,548.41,205.38Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.28,159.73c7.42,2.48,9.74,11.71,12.39,18.24a.64.64,0,0,0,1,.28c6.57-1.59,16.3-1.91,21.63,2.82a.16.16,0,0,0,.24-.22c-5-5.86-14.62-6.32-21.71-4.12-2.6-6.73-5.34-15.89-13.55-17.07C532.26,159.65,532.24,159.72,532.28,159.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.45,236.86c6.68,11.55,45.27,47.17,78.9,53.34,4.57.84,21.95-2.83,25.58-14.36,6.47-20.53,1.3-62.92-2-88.43-.65-5-46.91,5.26-45.71,12.87,1.33,8.42,6.28,39.38,5.52,39.73-2.77,1.28-32.34-11.48-51.75-15.67C483.23,221.38,481.31,228,486.45,236.86Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.45,200l-52.72,11.41s4.8,26.94,3.85,26.78-37.92-13.64-52.18-15.06-14.27,4.85-7,16.62S542,291,565.32,291c11.88,0,22.94-7.61,25.09-11.24C597.11,268.42,595.45,200,595.45,200Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.45,200l-52.72,11.41s4.8,26.94,3.85,26.78-37.92-13.64-52.18-15.06-14.27,4.85-7,16.62S542,291,565.32,291c11.88,0,22.94-7.61,25.09-11.24C597.11,268.42,595.45,200,595.45,200Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.12,234.72a12.81,12.81,0,0,0,2.77,6,11.8,11.8,0,0,0-1-3.2A12,12,0,0,0,518.12,234.72Zm41.9,47a12.79,12.79,0,0,0,2.76,6,11.46,11.46,0,0,0-1-3.2A12.45,12.45,0,0,0,560,281.77Zm31-32.26a12.4,12.4,0,0,0,1,3.2,11.4,11.4,0,0,0,1.78,2.83,11.5,11.5,0,0,0-1-3.19A12.28,12.28,0,0,0,591.06,249.51Zm-45.9.13a12.93,12.93,0,0,0,2.77,6,12.93,12.93,0,0,0-2.77-6Zm23.1,13.29a11.8,11.8,0,0,0,1,3.2A11.17,11.17,0,0,0,571,269a11.91,11.91,0,0,0-1-3.2A12.08,12.08,0,0,0,568.26,262.93Zm-2-32.4a12.84,12.84,0,0,0,2.77,6,11.85,11.85,0,0,0-1-3.19A11.57,11.57,0,0,0,566.22,230.53Zm23.46-24.09a12,12,0,0,0,1,3.21,11.3,11.3,0,0,0,1.78,2.83,12.17,12.17,0,0,0-1-3.2A12.63,12.63,0,0,0,589.68,206.44Zm-93.77,33.33a12.18,12.18,0,0,0,1.56-3,11.46,11.46,0,0,0,.74-3.26,11.67,11.67,0,0,0-1.56,3A11.46,11.46,0,0,0,495.91,239.77Zm31.22,21.55a11.42,11.42,0,0,0,1.56-3,11.82,11.82,0,0,0,.75-3.26,11.84,11.84,0,0,0-1.56,3A11.54,11.54,0,0,0,527.13,261.32ZM550.57,237a12.94,12.94,0,0,0,2.31-6.23,12,12,0,0,0-1.56,3A11.89,11.89,0,0,0,550.57,237Zm3,35.14a12.18,12.18,0,0,0,1.56-3,11.81,11.81,0,0,0,.75-3.27,12.94,12.94,0,0,0-2.31,6.23Zm30.07-3.8a11.67,11.67,0,0,0,1.56-3,11.91,11.91,0,0,0,.75-3.26,13,13,0,0,0-2.31,6.22Zm-9.48-49.67a12.36,12.36,0,0,0,1.56-3,11.89,11.89,0,0,0,.75-3.27,13,13,0,0,0-2.31,6.23Zm3.55,28.19a11.9,11.9,0,0,0,1.56-3,11.45,11.45,0,0,0,.74-3.27,12.24,12.24,0,0,0-1.56,3A11.38,11.38,0,0,0,577.75,246.9Zm-73.85,4.6a12.68,12.68,0,0,0,6.23,2.31,12.06,12.06,0,0,0-3-1.56A11.82,11.82,0,0,0,503.9,251.5Zm55.77-1.28a11.67,11.67,0,0,0,3,1.56,11.91,11.91,0,0,0,3.26.75,11.84,11.84,0,0,0-3-1.56A11.48,11.48,0,0,0,559.67,250.22Zm-5.26-33.13a11.07,11.07,0,0,0,3,1.56,11.55,11.55,0,0,0,3.26.75,12.18,12.18,0,0,0-3-1.56A11.82,11.82,0,0,0,554.41,217.09Zm29.92,10.4a11.52,11.52,0,0,0,3,1.56,11.81,11.81,0,0,0,3.27.75,12.94,12.94,0,0,0-6.23-2.31Zm-49.77,44.93a11.42,11.42,0,0,0,3,1.56,11.55,11.55,0,0,0,3.26.75,12.18,12.18,0,0,0-3-1.56A11.81,11.81,0,0,0,534.56,272.42Zm40.07,8.76a12.68,12.68,0,0,0,6.23,2.31,12.94,12.94,0,0,0-6.23-2.31Zm-43.18-44.6a11.56,11.56,0,0,0,3,1.57,11.88,11.88,0,0,0,3.27.74,12.18,12.18,0,0,0-3-1.56A11.81,11.81,0,0,0,531.45,236.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.18,238.45a81.59,81.59,0,0,0,2.09,11.93c.89,4,2.13,7.84,3.31,11.74,0,.09.16,0,.14-.05-1-3.92-1.75-7.91-2.61-11.87s-1.47-7.94-2.48-11.84C546.57,238.1,546.16,238.2,546.18,238.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.83,221.38c6.11-1.52,12.29-2.71,18.47-3.89s12.38-2.36,18.6-3.38c3.51-.58,7-1.17,10.56-1.63.09,0,.13.14,0,.16-6.1,1.52-12.28,2.74-18.44,4s-12.38,2.37-18.59,3.47c-3.51.62-7,1.17-10.56,1.63C545.74,221.71,545.66,221.42,545.83,221.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.43,275.23c-1-.86-2-1.59-3.06-2.4l-3-2.31c-2-1.56-4.07-3.11-6.1-4.68-4.06-3.14-8-6.38-12.07-9.57q-3.44-2.73-6.81-5.54c-.09-.07-.22.06-.13.14,2.77,2.6,5.56,5.18,8.44,7.66l-1.09-.53c-1.1-.55-2.18-1.14-3.26-1.74a.08.08,0,1,0-.08.14,28.42,28.42,0,0,0,3.15,2c.53.29,1.08.56,1.63.81l.8.35h0c.65.55,1.3,1.1,2,1.64q6,4.86,12.2,9.37c1.14.84,2.3,1.65,3.49,2.43s2.44,1.72,3.75,2.44C528.41,275.46,528.53,275.31,528.43,275.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.19,242.53c6.73,1.32,17.78-9.32,22-17.76.29-.58-.82-6.51-1.81-13.78-.59-4.42-1.14-9.35-1.32-13.88,0-.94-28.18,8-28.18,8s3.17,9.4,3.43,17.31a9.44,9.44,0,0,1-.12,1.87c0,.08,0,.19,0,.31C461.7,228.18,461.69,241.25,468.19,242.53Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.06,224.65a16.5,16.5,0,0,1-2.92,0c0-.12,0-.21,0-.31a9.29,9.29,0,0,0,.12-1.86c-.26-7.91-3.42-17.31-3.42-17.31s22.84-7.27,27.39-8C485.58,202.37,481.82,223.63,465.06,224.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,169.27c2.19,10.33-5.65,38.92-13.37,44.77-11.18,8.49-28.24,7.91-35.13-5.25-6.68-12.76,4.19-49.83,12.69-55C470.75,146.12,490.79,154,494,169.27Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.44,185.74c0-.07.12.14.1.21-.58,1.92-.92,4.2.65,5.31a.06.06,0,0,1-.05.11C466.1,190.49,466.58,187.46,467.44,185.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.7,184.19c3.16.6,1.73,6.89-1.2,6.33S467.05,183.69,469.7,184.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.34,183c0-.08-.17.06-.19.14-.38,2-1.14,4.14-3,4.39-.06,0-.08.1,0,.11C455.31,187.84,456.3,184.94,456.34,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.07,180.59c-3.08-1-4.76,5.27-1.9,6.15S457.65,181.39,455.07,180.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.16,181.1a26.1,26.1,0,0,1-2.43-1,4.27,4.27,0,0,1-2.28-1.54,1.37,1.37,0,0,1,.33-1.63,3.37,3.37,0,0,1,3.42-.12,4.94,4.94,0,0,1,2.71,2.33A1.45,1.45,0,0,1,473.16,181.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.36,176.87a23.28,23.28,0,0,0,2.64-.08,4.28,4.28,0,0,0,2.68-.59,1.37,1.37,0,0,0,.3-1.64,3.39,3.39,0,0,0-3.14-1.37,4.94,4.94,0,0,0-3.38,1.18A1.45,1.45,0,0,0,453.36,176.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.12,203.55c-.57.35-1.17.87-1.89.77a5.25,5.25,0,0,1-2-1,.07.07,0,0,0-.1.08,2.69,2.69,0,0,0,2.23,1.62,2.13,2.13,0,0,0,1.92-1.38C465.35,203.58,465.21,203.5,465.12,203.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.4,197.26a6.78,6.78,0,0,1-5.09,1.94,8.67,8.67,0,0,1-2.41-.43,1.91,1.91,0,0,1-.44-.16,4.45,4.45,0,0,1-.42-.16.5.5,0,0,1-.29-.53h0a.6.6,0,0,1,.06-.19v0l0-.17c.31-1.51,1-3.75,1-3.75-.61.15-3.69.77-3.47,0,1.87-6.39,3.94-13.5,7.14-19.47a.18.18,0,0,1,.34.13c-1.54,6.21-4.17,12.12-5.82,18.34a11.85,11.85,0,0,1,3.34-.24c.2.11-1.36,4.32-1.44,5a.14.14,0,0,0,0,.07c2.44.9,4.51.57,7.34-.57C464.43,197,464.56,197.13,464.4,197.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.91,199a8.2,8.2,0,0,0,3.06,2.84,3.66,3.66,0,0,0,2.23.34c1.66-.28,1.83-1.76,1.65-3.06a9.17,9.17,0,0,0-.55-2A10.65,10.65,0,0,1,457.91,199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,201.84a3.66,3.66,0,0,0,2.23.34c1.66-.28,1.83-1.76,1.65-3.06C463.09,199.14,461.27,200.17,461,201.84Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.44,194.79s10.46-15.48,10-24.75c-.2-4.19-5.75-7.28-5.75-7.28a9.43,9.43,0,0,0-2.5-9.63c-4.7-4.89-16.7-4.44-16.7-4.44s-7.18-11.57-18.36-7.68-4.65,16.66-4.65,16.66-4.31,5.5,5.29,10.45c9.34,4.82,29.1,1.52,29.1,1.52a68.17,68.17,0,0,0-.71,20.26A6.2,6.2,0,0,0,488.44,194.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.62,148.74a19.13,19.13,0,0,1,7.77-1,20.88,20.88,0,0,1,6.89,1.43c3.87,1.61,7.23,4.69,7.67,9a8,8,0,0,1-1.83,6c-.06.06-.16,0-.1-.11,2.69-3,1.6-8-.88-10.71-2.81-3.11-7.28-4.46-11.35-4.84a33.89,33.89,0,0,0-8.11.45A.12.12,0,0,1,471.62,148.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.06,145.9c1.06-3,3.79-4.86,6.79-5.65a16,16,0,0,1,10.35.88,20.15,20.15,0,0,1,8.16,6.7c.05.07-.06.15-.11.09-3.88-5.08-10.18-8.17-16.62-7.14-2.87.46-5.8,1.78-7.25,4.44a9.62,9.62,0,0,0-.16,8.14,18,18,0,0,0,6.69,7.41c.06,0,0,.14-.06.1a18.5,18.5,0,0,1-6.72-6.34A10.45,10.45,0,0,1,447.06,145.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.39,168.52a33,33,0,0,0,13.66,3.08,68,68,0,0,0,14.59-1.27c2.8-.53,5.59-1.16,8.35-1.85a.07.07,0,0,1,0,.14A74.07,74.07,0,0,1,475,172.46a37.25,37.25,0,0,1-14.3-.84,31.8,31.8,0,0,1-7.32-3C453.28,168.58,453.33,168.49,453.39,168.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484,193.18s7.56-8.67,11.57-5.87-2.39,15.85-7.58,17.18a5.12,5.12,0,0,1-6.52-3.46Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.62,191a.07.07,0,0,1,0,.13c-3.65,1-5.84,4.09-7.49,7.32,1.18-1.18,2.67-1.74,4.27-.31.09.07,0,.21-.11.17a3.16,3.16,0,0,0-3.56.72,15.11,15.11,0,0,0-1.94,2.61c-.2.3-.75.07-.59-.28,0,0,0-.05,0-.08C484.64,196.82,488.78,190.94,493.62,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460,230.13c0-.06.1,0,.1,0,0,5.57.31,18.46,9.87,17.2,3.85-.51,7.25-2.88,10.06-5.17a51.3,51.3,0,0,0,7.69-7.91,72,72,0,0,0,7-10c.08-.15.31,0,.24.14a52.83,52.83,0,0,1-6.18,10.45,44.11,44.11,0,0,1-8.28,8.73c-3,2.37-6.64,4.74-10.73,5.1a7.81,7.81,0,0,1-8.22-4.89C459.78,239.58,459.54,234.56,460,230.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.7,321.45c-13.75,18.63-28.09,40.24-31.58,63.6a.31.31,0,0,0,.61.12,137,137,0,0,1,6.08-18.7c9-2.49,17.91-4.53,22.66-13.51,4.84-9.22,4.23-21.25,3.31-31.3C127.71,321.12,127,321.1,126.7,321.45Z",
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,321.45c-13.75,18.63-28.09,40.24-31.58,63.6a.31.31,0,0,0,.61.12,137,137,0,0,1,6.08-18.7c9-2.49,17.91-4.53,22.66-13.51,4.84-9.22,4.23-21.25,3.31-31.3C127.71,321.12,127,321.1,126.7,321.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94,366.29c6.18-13.86,14.11-27.78,24.19-39.18.07-.08.18,0,.11.11-6.6,8.12-11.61,17-16.51,26,4.55-4.62,9.54-8.77,13.86-13.67.08-.09.22.05.14.14-4.29,5.14-9,10.73-14.54,14.53q-2.25,4.14-4.54,8.3c.37-.21.76-.4,1.15-.59.06,0,.12.07.06.1-.43.22-.85.44-1.29.63-.72,1.31-1.44,2.62-2.19,3.93C102.22,366.84,101.81,366.59,101.94,366.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,361.46a82.92,82.92,0,0,0,10.56-7c.09-.07.22,0,.13.13a56.35,56.35,0,0,1-10.54,7.18C106.52,361.8,106.37,361.55,106.54,361.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,381.58c0,.28.51.28.5,0,.07-7.7,0-15.42.12-23.15,2-4,6.2-6.18,9.14-9.36a40.68,40.68,0,0,0,5.49-7.64,54.71,54.71,0,0,0,6.36-21.22c.82-8.23-2.31-35.38-5.77-34.44-1.8.49-7.62,13.94-9.17,18.39a128.18,128.18,0,0,0-5.47,22.54C91.92,344.78,92.15,363.36,93.53,381.58Z",
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,381.58c0,.28.51.28.5,0,.07-7.7,0-15.42.12-23.15,2-4,6.2-6.18,9.14-9.36a40.68,40.68,0,0,0,5.49-7.64,54.71,54.71,0,0,0,6.36-21.22c.82-8.23-2.31-35.38-5.77-34.44-1.8.49-7.62,13.94-9.17,18.39a128.18,128.18,0,0,0-5.47,22.54C91.92,344.78,92.15,363.36,93.53,381.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47,348.4l0,0c.42-9.73,2.61-19.56,4.66-29,2.22-10.17,4.8-19.75,10-28.82a.15.15,0,0,1,.26.15,107.19,107.19,0,0,0-8,22.12c.35-.55.77-1.07,1.14-1.58.14-.21.48,0,.34.19a14.6,14.6,0,0,1-1.64,2.31.09.09,0,0,1-.07,0c-1.8,7.27-3.09,14.71-4.2,22.12.08-.09.16-.19.25-.28a.07.07,0,0,1,.11.08c-.14.25-.29.49-.44.74-.56,3.76-1.07,7.52-1.59,11.24,6.7-5.72,12.42-12.48,15.65-20.8,0,0,.08,0,.06,0-3.16,8.63-8.14,16.3-15.82,21.54l-.42,3c0,.21-.36.16-.36,0,0-.89,0-1.78.08-2.67A.2.2,0,0,1,93.47,348.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63,334.3c5.12-7.65,9.91-15.07,13.65-23.52,0-.1.21,0,.17.07-3.16,8.39-7.58,16.9-13.56,23.64C96.76,334.63,96.53,334.45,96.63,334.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.44,308.89c2.12-3.75,4.36-7.41,6.35-11.24.06-.1.21,0,.16.1a58.19,58.19,0,0,1-6.19,11.33C103.62,309.27,103.31,309.11,103.44,308.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.61,310.52s0,.07,0,.07S102.57,310.52,102.61,310.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.32,359.34a77.9,77.9,0,0,1-1.8,15.15c.08.55.16,1.09.24,1.66a71.81,71.81,0,0,0,2.71-16.89.52.52,0,0,0,0-.53h0a112,112,0,0,0-1.7-22.89c-2.38-14.14-7.59-27.7-17.45-38.3a.71.71,0,0,0-1.09.23c-4,10.11-2.59,22.18.8,32.27a59.18,59.18,0,0,0,7.82,15.33C81.26,350.12,85.57,354.14,88.32,359.34Z",
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.32,359.34a77.9,77.9,0,0,1-1.8,15.15c.08.55.16,1.09.24,1.66a71.81,71.81,0,0,0,2.71-16.89.52.52,0,0,0,0-.53h0a112,112,0,0,0-1.7-22.89c-2.38-14.14-7.59-27.7-17.45-38.3a.71.71,0,0,0-1.09.23c-4,10.11-2.59,22.18.8,32.27a59.18,59.18,0,0,0,7.82,15.33C81.26,350.12,85.57,354.14,88.32,359.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,302.27c9.34,15.16,15.84,33.14,16.64,51.05,0,.32-.52.4-.57.08-.22-1.61-.46-3.21-.72-4.79h0C83,344.9,79,341,76.25,336.36c0-.08.07-.17.13-.1,3.37,3.84,6.51,7.78,10.3,11.21-.67-4-1.46-7.86-2.4-11.7l-.74-.87c-.16-.19.11-.46.28-.27l.22.24a134.06,134.06,0,0,0-4.88-15.51c-2.38-2.83-5-5.28-6.77-8.7a.07.07,0,1,1,.12-.07c1.4,2,2.74,3.92,4.32,5.73.63.72,1.33,1.4,2,2.1a120.4,120.4,0,0,0-7.65-15.94A.21.21,0,0,1,71.52,302.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,321c3,4.07,6.46,7.94,9.27,12.15.08.12-.1.24-.2.15-3.61-3.39-6.66-8-9.27-12.18C73.12,321,73.32,320.85,73.41,321Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,334.06l.13.13c.09.08,0,.22-.14.13L83,334.2A.1.1,0,0,1,83.1,334.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,331.42c.75,7.8,4.86,17.12,9.86,23.13a24.59,24.59,0,0,0,8,6.24c3.46,1.71,7.08,3.68,10.67,5.09a70.28,70.28,0,0,1,3.77,13.42c.12-.39.23-.8.35-1.19-2.3-19.75-15.08-36.63-31.43-47.47A.8.8,0,0,0,56.88,331.42Z",
    style: {
      fill: "#58D279"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,331.42c.75,7.8,4.86,17.12,9.86,23.13a24.59,24.59,0,0,0,8,6.24c3.46,1.71,7.08,3.68,10.67,5.09a70.28,70.28,0,0,1,3.77,13.42c.12-.39.23-.8.35-1.19-2.3-19.75-15.08-36.63-31.43-47.47A.8.8,0,0,0,56.88,331.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.53,337.25c-.12-.1,0-.31.17-.21a66.89,66.89,0,0,1,20.83,25.67c.12.27-.25.51-.41.24q-1.14-2-2.32-3.9h0c-3.73-.7-7.27-3.33-10-5.82a.08.08,0,0,1,.11-.11,23.49,23.49,0,0,0,4.72,3.32c1.53.77,3.16,1.25,4.75,1.87Q78.25,355,76,352a43.61,43.61,0,0,1-11.22-6.3c-.1-.08,0-.25.11-.18a112.3,112.3,0,0,0,10.42,5.57A91.63,91.63,0,0,0,68,342.48c-1.27-.67-2.55-1.34-3.78-2.06-.1-.06,0-.23.08-.19a13.42,13.42,0,0,1,2.9,1.42C65.68,340.16,64.16,338.69,62.53,337.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,344.07a7.17,7.17,0,0,1,.63.45c.06.06,0,.13-.08.1a4.28,4.28,0,0,1-.66-.37A.11.11,0,0,1,62.88,344.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.05 422.07 70.25 422.07 73.86 381.28 74.66 372.28 110.63 372.28 111.43 381.28 115.05 422.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.43 381.28 73.86 381.28 74.66 372.28 110.63 372.28 111.43 381.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.51,
    y: 365.99,
    width: 40.26,
    height: 8.9,
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.08001097fed3e7626a87cd855305c883.svg";
export { ForwardRef as ReactComponent };